exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DiabetesDeviceSummary{margin:20px 0}.DiabetesDeviceSummary-header{font-size:14px;font-weight:500;margin-bottom:16px}.DiabetesDeviceSummary-selections{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.DiabetesDeviceSummary-device{width:144px;height:100px;margin-bottom:20px}.DiabetesDeviceSummary-divider{width:284px;height:2px;border-top:1px solid var(--border-primary);margin-bottom:16px}", ""]);

// exports
